<template>
  <div class="main">
    <div>
      <div class="titlefont">
        <div class="titleAnimation">
          <div class="title">{{ technology.title }}</div>
          <div class="desc">
            {{ technology.url }}
          </div>
        </div>
      </div>
      <div class="conMain">
        <div class="con">
          <div class="conShow boxShow">
            <div class="imgBox" v-if="activeName === 'active0'">
              <img src="../img/pic3.jpg" />
            </div>
            <div class="imgBox" v-else><img src="../img/pic5.jpg" /></div>
            <div class="conTit">
              <div class="topLine"></div>
              <div class="leftLine"></div>
              <div class="conText">
                <p>APPLICATION SKILLS</p>
                <p>应用技能</p>
              </div>
            </div>
            <div class="rightTab">
              <el-tabs v-model="activeName">
                <el-tab-pane
                  v-for="item in technology.ttitleAndDesc.slice(0, 2)"
                  :key="item.id"
                  :label="item.title"
                  :name="item.name"
                >
                  <!-- {{ item.desc.split("/") }} -->
                  <ul
                    class="items"
                    :class="{ onShow: item.desc.split(',').length > 30 }"
                  >
                    <li v-for="(val, i) in item.desc.split(',')" :key="i">
                      {{ val }}
                    </li>
                  </ul>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <div class="styleBox styleShow">
            <div v-if="technology.ttitleAndDesc" :class="{bg1:true,bigbg1: technology.ttitleAndDesc.slice(2, 3)[0].desc.split(',').length > 6}">
              {{ technology.ttitleAndDesc.slice(2, 3)[0].title }}
            </div>
            <ul>
              <li :class="{firstRow:technology.ttitleAndDesc.slice(2, 3)[0].desc.split(',').length < 7}"
                v-for="(item, index) in technology.ttitleAndDesc
                  .slice(2, 3)[0]
                  .desc.split(',')"
                :key="index"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    technology: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeName: "active0",
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.styleBox .firstRow{
  flex: 1;
}
</style>
